/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Card, message, Result, Spin } from 'antd';
import React, { useContext, useEffect, useRef, useState } from 'react';
import 'react-credit-cards/es/styles-compiled.css';
import { useHistory, useLocation } from 'react-router-dom';
import LogosEmpresaAseguradora from '../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../components/ResponsiveContainer';
import SolicitudRealizada from '../components/SolicitudRealizada';
import { USER_STATES } from '../constants';
import EmpresaContext from '../context/empresa-context';
import {
  SolicitudProvider,
  useSolicitudContext
} from '../context/solicitud-context';
import UserContext from '../context/user-context';
import WhatsAppContext from '../context/whatsapp-context';
import { errorHandler } from '../utils';
import { instanceRef } from '../utils/axios';
import SolicitudHogarForm from './hogar/SolicitudHogarForm';
import SolicitudPersonalForm from './personal/SolicitudPersonalForm';
import SolicitudTelefonicaForm from './SolicitudTelefonicaForm';
import SolicitudTelefonicaVehiculoForm from './SolicitudTelefonicaVehiculoForm';
import SolicitudVehiculoForm from './vehiculo/SolicitudVehiculoForm';
import SolicitudViajeForm from './viaje/SolicitudViajeForm';

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const SolicitudForm = ({ cotizacionesInfo, ...props }) => {
  const [cotizacion] = cotizacionesInfo;
  return (
    <>
      {[1].includes(cotizacion.producto.codigo) && (
        <>
          <SolicitudVehiculoForm {...props} />
        </>
      )}
      {[2, 3, 6].includes(cotizacion.producto.codigo) && (
        <>
          <SolicitudPersonalForm {...props} />
        </>
      )}
      {[4, 5].includes(cotizacion.producto.codigo) && (
        <>
          <SolicitudHogarForm {...props} />
        </>
      )}
      {[8].includes(cotizacion.producto.codigo) && (
        <>
          <SolicitudViajeForm {...props} />
        </>
      )}
    </>
  );
};

const PreSolicitudFormFinal = ({ fullPath, ...props }) => {
  const [cotizaciones, setCotizaciones] = useState();
  const [debouncing, setDebouncing] = useState();
  const [cotizacionesInfo, setCotizacionesInfo] = useState();
  const [cotizacionesEnviadas, setCotizacionesEnviadas] = useState(null);
  const [listaCotizacionesEnviadas, setListaCotizacionesEnviadas] = useState();
  const { user, userState } = useContext(UserContext);
  const { empresa, updateProducto, setEmpresaProducto } = useContext(
    EmpresaContext
  );
  const { vigenciaPagosContext } = useSolicitudContext();
  const anterior = usePrevious(vigenciaPagosContext);
  const { actualizarTexto } = useContext(WhatsAppContext);
  const [solicitado, setSolicitado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [loadingCotizacionInfo, setLoadingCotizacionInfo] = useState(false);
  const [token, setToken] = useState();
  const [tokenCotizacionPersona, setTokenCotizacionPersona] = useState();
  const [isMasiva, setIsMasiva] = useState();
  const [pendienteAutorizacion, setPendienteAutorizacion] = useState();
  const history = useHistory();

  const existeCotizacionEnviada =
    cotizacionesEnviadas && cotizacionesEnviadas.length > 0;

  const noExisteCotizacionEnviada =
    cotizacionesEnviadas && cotizacionesEnviadas.length === 0;

  const noEsCliente = user && user['cognito:groups'][0] !== 'CLIENTE';

  const esClienteONoEstaLogueado =
    (user && user['cognito:groups'][0] === 'CLIENTE') ||
    (!user &&
      (userState === USER_STATES.loggingEnd ||
        userState === USER_STATES.notLogged));

  const onDebounce = () => {
    setDebouncing(true);
  };

  const getCotizacionInfo = async () => {
    setLoadingCotizacionInfo(true);
    const tokenAVerificar = props.match.params.token;
    const esMasiva = props.match.params.tipo; // Identificar si es masiva
    try {
      const url = esMasiva
        ? `cotizacionmasiva/info?token=${tokenAVerificar}`
        : `cotizacion/info?token=${tokenAVerificar}`;
      const response = await instanceRef.instance.post(url, { fullPath });
      if (response.data && response.data.data) {
        setTokenCotizacionPersona(response.data.data[0].tokenPersonaOriginal);
        setToken(response.data.data[0].token);
        setIsMasiva(!!esMasiva);
        setCotizacionesInfo(response.data.data);
        setSolicitado(
          response.data.data.some((item) => item.solicitado === true)
        );
      }
      updateProducto(response.data.data[0].id_producto);
      getEmpresaProducto(response.data.data[0].id_producto);
    } catch (err) {
      errorHandler(err, 'Error al cargar la solicitud');
      if (err.response && err.response.status === 400) {
        if (esMasiva) {
          history.push(
            `/regenerar-token?flujo=cotizacionmasiva&tokenExpirado=${tokenAVerificar}`
          );
        } else {
          history.push(
            `/regenerar-token?flujo=cotizacion&tokenExpirado=${tokenAVerificar}`
          );
        }
      }
    }

    setLoadingCotizacionInfo(false);
  };

  const getCotizacion = async (vigenciaParam) => {
    try {
      let paramsVigencia = {};
      if (vigenciaParam) {
        paramsVigencia = vigenciaParam;
      }
      setLoading(true);
      let url = isMasiva
        ? `cotizacionmasiva/token?token=${tokenCotizacionPersona}`
        : `cotizacion/token?token=${token}&solicitar=true&estado=ENVIADO`;
      const response = await instanceRef.instance.post(url, {
        ...paramsVigencia
      });
      setLoaded(true);
      if (
        response.data &&
        response.data.data &&
        response.data.data.length === 0
      ) {
        message.error('No se ha encontrado la cotización');
        setCotizaciones([]);
      } else {
        if (
          response.data.data[0].enviado === 'NO' &&
          ((user && user['cognito:groups'][0] === 'CLIENTE') ||
            (!user &&
              (userState === USER_STATES.loggingEnd ||
                userState === USER_STATES.notLogged)))
        ) {
          url = isMasiva
            ? `cotizacionmasiva/cotizar?token=${token}`
            : `cotizacion/cotizar?token=${token}`;
          await instanceRef.instance.get(url);
        }
        setCotizaciones(
          response.data.data.filter(
            (item) => item.planes && item.planes.length > 0
          )
        );
      }
    } catch (error) {
      errorHandler(error, 'No se pudo obtener la cotización');
      setCotizaciones([]);
    }

    setLoading(false);
    setLoaded(true);
    setDebouncing(false);
  };

  const getEmpresaProducto = async (idProducto) => {
    try {
      const response = await instanceRef.instance.get(
        `/empresaproducto/empresa/${empresa.id}/producto/${idProducto}`
      );
      setEmpresaProducto(response.data.data);
    } catch (error) {
      errorHandler(error, 'No se pudo obtener empresa prdocuto');
    }
  };

  useEffect(() => {
    setListaCotizacionesEnviadas(
      (cotizaciones || []).filter((item) =>
        (cotizacionesEnviadas || []).find(
          (enviadas) =>
            enviadas.id === item.id || enviadas.id === item.id_cotizacion_masiva
        )
      )
    );
  }, [cotizaciones, cotizacionesEnviadas]);

  useEffect(() => {
    let cambioEncontrado = false;
    if (vigenciaPagosContext && anterior) {
      if (
        vigenciaPagosContext.pagos?.cantidad_pagos &&
        vigenciaPagosContext.pagos.cantidad_pagos !==
          anterior.pagos?.cantidad_pagos
      ) {
        getCotizacion(vigenciaPagosContext);
        cambioEncontrado = true;
      } else if (
        vigenciaPagosContext.cantidad_pagos &&
        vigenciaPagosContext.cantidad_pagos !== anterior.cantidad_pagos
      ) {
        getCotizacion(vigenciaPagosContext);
        cambioEncontrado = true;
      }
      if (vigenciaPagosContext.cantidad_dias !== anterior.cantidad_dias) {
        getCotizacion(vigenciaPagosContext);
        cambioEncontrado = true;
      }
    } else if (vigenciaPagosContext && !anterior) {
      if (vigenciaPagosContext.pagos?.cantidad_pagos) {
        getCotizacion(vigenciaPagosContext);
        cambioEncontrado = true;
      }
    }
    if (!cambioEncontrado) {
      setDebouncing(false);
    }
  }, [vigenciaPagosContext]);

  useEffect(() => {
    if (empresa) getCotizacionInfo();
  }, [empresa]);

  useEffect(() => {
    actualizarTexto(`Solicitud: ${window.location.href} \n`);
  }, []);

  useEffect(() => {
    if (cotizacionesInfo) {
      setCotizacionesEnviadas(
        cotizacionesInfo.filter(
          (e) => e.estado === 'ENVIADO' || e.estado === 'PENDIENTE ENVIO'
        )
      );
    }
  }, [cotizacionesInfo]);

  useEffect(() => {
    const todasCotizacionesPendienteAutorizacion = !(
      cotizaciones && cotizaciones.length > 0
    )
      ? false
      : cotizaciones.every(
          (item) => item?.autorizacionFlujo[0]?.estado === 'PENDIENTE'
        );

    setPendienteAutorizacion(todasCotizacionesPendienteAutorizacion);
  }, [cotizaciones]);

  return (
    <>
      <LogosEmpresaAseguradora />
      <Spin spinning={loadingCotizacionInfo}>
        {solicitado ? (
          <SolicitudRealizada />
        ) : (
          <>
            {cotizacionesInfo &&
              cotizacionesInfo[0]?.tipo_venta !== 'telefonica' && (
                <>
                  {noEsCliente && (
                    <SolicitudForm
                      cotizacionesInfo={cotizacionesInfo}
                      cotizaciones={cotizaciones}
                      debouncing={debouncing}
                      onDebounce={onDebounce}
                      token={token}
                      loading={loading}
                      loaded={loaded}
                      isMasiva={isMasiva}
                    />
                  )}
                  {esClienteONoEstaLogueado &&
                    existeCotizacionEnviada &&
                    !pendienteAutorizacion && (
                      <SolicitudForm
                        cotizacionesInfo={cotizacionesInfo}
                        cotizaciones={listaCotizacionesEnviadas}
                        debouncing={debouncing}
                        onDebounce={onDebounce}
                        token={token}
                        loading={loading}
                        loaded={loaded}
                        isMasiva={isMasiva}
                      />
                    )}
                  {esClienteONoEstaLogueado &&
                    (noExisteCotizacionEnviada || pendienteAutorizacion) && (
                      <>
                        {empresa && (
                          <ResponsiveContainer>
                            <Card>
                              <Result
                                title="Cotización pendiente de autorización"
                                subTitle="La cotización está pendiente de autorización. Una vez aprobada, le enviaremos una notificación"
                                extra={
                                  empresa.tiene_landing
                                    ? [
                                        <Button
                                          type="primary"
                                          key="console"
                                          onClick={() => {
                                            window.location.href = `/`;
                                          }}
                                        >
                                          Ir al Inicio
                                        </Button>
                                      ]
                                    : null
                                }
                              />
                            </Card>
                          </ResponsiveContainer>
                        )}
                      </>
                    )}
                </>
              )}

            {/* VENTA TELEFONICA */}
            {cotizacionesInfo &&
              cotizacionesInfo?.[0]?.tipo_venta === 'telefonica' && (
                <>
                  {noEsCliente && (
                    <SolicitudForm
                      cotizacionesInfo={cotizacionesInfo}
                      cotizaciones={cotizaciones}
                      debouncing={debouncing}
                      onDebounce={onDebounce}
                      token={token}
                      loading={loading}
                      loaded={loaded}
                    />
                  )}
                  {esClienteONoEstaLogueado &&
                    cotizacionesInfo?.[0]?.producto.id !== 1 &&
                    cotizacionesInfo?.[0]?.producto.id !== 7 && (
                      <>
                        <SolicitudTelefonicaForm
                          cotizaciones={cotizaciones}
                          loading={loading}
                          loaded={loaded}
                          debouncing={debouncing}
                          onDebounce={onDebounce}
                        />
                      </>
                    )}
                  {esClienteONoEstaLogueado &&
                    (cotizacionesInfo?.[0]?.producto.id === 1 ||
                      cotizacionesInfo?.[0]?.producto.id === 7) && (
                      <>
                        <SolicitudTelefonicaVehiculoForm
                          cotizaciones={cotizaciones}
                          loading={loading}
                          loaded={loaded}
                          debouncing={debouncing}
                          onDebounce={onDebounce}
                        />
                      </>
                    )}
                </>
              )}

            {cotizaciones && cotizaciones.length === 0 && (
              <div style={{ paddingTop: 200 }}>
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href = '/';
                  }}
                >
                  Salir
                </Button>
              </div>
            )}
            {/* {getLink(getProductoActual()) === LINKS_PRODUCTOS.VIAJE && (
              <>
                {(solicitado && <SolicitudRealizada />) || (
                  <SolicitudViajeForm
                    {...props}
                    cotizaciones={cotizaciones}
                    loading={loading}
                  />
                )}
              </>
            )} */}
          </>
        )}
      </Spin>
    </>
  );
};

const PreSolicitudForm = (props) => {
  const location = useLocation();
  const fullPath = location.pathname;
  return (
    <SolicitudProvider>
      <PreSolicitudFormFinal fullPath={fullPath} {...props} />
    </SolicitudProvider>
  );
};

export default PreSolicitudForm;
